import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    override parse(value: string): NgbDateStruct | null {
        const dateParts = value.split('.');
        if (dateParts.length === 3) {
            const day = parseInt(dateParts[0].padStart(2, '0'), 10);
            const month = parseInt(dateParts[1].padStart(2, '0'), 10);
            const year = parseInt(dateParts[2], 10);
            if (day && month && year) {
                return { year, month, day };
            }
        }
        return null;
    }

    override format(date: NgbDateStruct): string {
        return `${String(date.day).padStart(2, '0')}.${String(date.month).padStart(2, '0')}.${date.year}`;
    }
}
